<span class="av-delta av-chart-tone--{{ tone() }}">
  <mat-icon class="av-delta__icon" aria-hidden="true">{{ icon() }}</mat-icon>
  <span class="av-delta__value av-value-text">
    @if (unit() === 'points') {
      {{ sign()
      }}{{
        'app.reports.monitoring.delta.points'
          | translate: { value: points() | number: '1.1-1' : language() }
      }}
    } @else {
      {{ sign() }}{{ fraction() | percent: '1.1-1' : language() }}
    }
  </span>
</span>
@if (previousMonth(); as previousMonth) {
  <span class="av-metric-hint">{{
    'app.reports.monitoring.delta.vsPrevious' | translate: { month: previousMonth }
  }}</span>
}
